import moment from 'moment';
import * as planningNumeriqueConf from '@/components/creationOpportunite/configuration/planningNumeriqueConf';
import getAnneeSemaine from '@/services/general/getAnneeSemaine';
import ajoutLignesCommandeProduitFace from './ajoutProduitFace';
import ajoutLignesCommandeProduitNumerique from './ajoutProduitNumerique';
import ajoutLignesCommandeProduitReseauTempo from './ajoutProduitReseauTempo';
import ajoutLignesCommandeProduitReseauLc from './ajoutProduitReseauLc';
import ajoutLignesCommandeProduitReseauNumeriqueViaId from './ajoutProduitReseauNumerique';

export function datesStringToPeriodes(periode) {
  const mesPeriodes = periode.trim().split(' - ');
  const listDates = [];
  mesPeriodes.forEach(el => {
    if (el.includes('du')) {
      let dateDebut = moment(el.substring(9, 13) + el.substring(6, 8) + el.substring(3, 5));
      const dateFin = moment(el.substring(23, 27) + el.substring(20, 22) + el.substring(17, 19));
      while (dateDebut <= dateFin) {
        listDates.push(moment(dateDebut, 'DD/MM/YYYY'));
        dateDebut = dateDebut.add(1, 'days');
      }
    } else {
      listDates.push(moment(el, 'DD/MM/YYYY'));
    }
  });

  listDates.sort((a, b) => a.diff(b, 'days'));
  const listPeriode = listDates.reduce((acc, date) => {
    const group = acc[acc.length - 1];
    if (moment(date).diff(moment(group[group.length - 1] || date), 'days') > 1) {
      acc.push([date]);
    } else {
      group.push(date);
    }
    return acc;
  }, [[]]);
  return listPeriode.map(periode => ({
    debut: moment(periode[0]).toDate(),
    fin: moment(periode[periode.length - 1]).toDate(),
  }));
}

function weeksStringToPeriodes(periode) {
  const listDates = Array.from(periode.trim().split(' - '), el => moment(el, '[S]w / YYYY'));
  listDates.sort((a, b) => a.diff(b, 'weeks'));
  const listPeriode = listDates.reduce((acc, date) => {
    const group = acc[acc.length - 1];
    if (moment(date).diff(moment(group[group.length - 1] || date), 'weeks') > 1) {
      acc.push([date]);
    } else {
      group.push(date);
    }
    return acc;
  }, [[]]);
  return listPeriode.map(periode => ({
    debut: moment(periode[0]).toDate(),
    fin: moment(periode[periode.length - 1]).add(6, 'days').toDate(),
  }));
}

export default async function ajoutProduitSurDevis(devisCommande, opportunite, societe, oldDevis,
  tauxTvaDefault) {
  if (Object.values(opportunite.data.produits).flat().flat().length) {
    const req = [];
    opportunite.data.produits.panneauxLc.forEach((el, index) => {
      const listIdProduits = {
        tlpe: societe.produitIdDefautTlpe,
        fraisTechnique: societe.produitIdDefautFraisTechnique,
        pose: societe.produitIdDefautPose,
        produit: societe.produitIdDefautUnitaire,
      };
      req.push(ajoutLignesCommandeProduitFace(
        devisCommande, el, listIdProduits, (index + 1) * 100, tauxTvaDefault));
    });
    opportunite.data.produits.panneauxNumeriques.forEach((el, index) => {
      const listIdProduits = {
        tlpe: societe.produitIdDefautTlpe,
        fraisTechnique: societe.produitIdDefautFraisTechnique,
        pose: societe.produitIdDefautPose,
        produit: societe.produitIdDefautEcranNumerique,
      };
      let result = [];
      if (el.extensionOpportunite.periode.includes('S')) {
        result = weeksStringToPeriodes(el.extensionOpportunite.periode);
      } else {
        result = datesStringToPeriodes(el.extensionOpportunite.periode);
      }
      result.forEach(res => {
        req.push(ajoutLignesCommandeProduitNumerique(
          devisCommande,
          { ...el, periodeCal: res },
          listIdProduits,
          (index + 1) * 100,
          tauxTvaDefault),
        );
      });
    });
    opportunite.data.produits.reseauxTempo.forEach((el, index) => {
      const listIdProduits = {
        tlpe: societe.produitIdDefautTlpe,
        fraisTechnique: societe.produitIdDefautFraisTechnique,
        pose: societe.produitIdDefautPose,
        produit: societe.produitIdDefautRegroupement,
      };
      let ligneOldDevis = null;
      if (el.extensionOpportunite.demande) {
        if (oldDevis) {
          const anneeSemaine = getAnneeSemaine(
            el.extensionOpportunite.annee,
            el.extensionOpportunite.semaine,
          );
          ligneOldDevis = oldDevis.lignesCommande
            .find(ligne => ligne.produitId === el.num
                  && ligne.ligneReseau.anneeSemaine.toString() === anneeSemaine);
        }
      }
      req.push(ajoutLignesCommandeProduitReseauTempo(
        devisCommande,
        el,
        listIdProduits,
        (index + 1) * 100,
        ligneOldDevis,
        tauxTvaDefault),
      );
    });
    opportunite.data.produits.reseauxLc.forEach((el, index) => {
      const listIdProduits = {
        tlpe: societe.produitIdDefautTlpe,
        fraisTechnique: societe.produitIdDefautFraisTechnique,
        pose: societe.produitIdDefautPose,
        produit: societe.produitIdDefautRegroupementLc,
      };
      req.push(ajoutLignesCommandeProduitReseauLc(
        devisCommande, el, listIdProduits, (index + 1) * 100, tauxTvaDefault));
    });
    opportunite.data.produits.reseauxNumeriques.forEach((el, index) => {
      const listIdProduits = {
        tlpe: societe.produitIdDefautTlpe,
        fraisTechnique: societe.produitIdDefautFraisTechnique,
        pose: societe.produitIdDefautPose,
        produit: societe.produitIdDefautRegroupementNumerique,
      };
      let result = [];
      const typeTarification = planningNumeriqueConf.TYPE_TARIFICATION
        .find(type => type.value === el.extensionOpportunite.typeTarification);
      if (typeTarification.granularity === planningNumeriqueConf.GRANULARITY_DAY) {
        result = datesStringToPeriodes(el.extensionOpportunite.periode);
      }
      if (typeTarification.granularity === planningNumeriqueConf.GRANULARITY_WEEK) {
        result = weeksStringToPeriodes(el.extensionOpportunite.periode);
      }
      result.forEach(res => {
        req.push(ajoutLignesCommandeProduitReseauNumeriqueViaId(
          devisCommande,
          { ...el, periodeCal: res },
          listIdProduits,
          (index + 1) * 100,
          tauxTvaDefault),
        );
      });
    });
    const res = await Promise.all(req);
    res.forEach(el => {
      devisCommande.lignesCommande.push(el);
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/devis/ajoutProduit/ajoutProduit.js